import React, { useContext } from 'react';
import modalContext from '../../context/modal/modalContext';
import CustomModal from '../../components/CustomModal';
import ExternalLink from '../../components/ExternalLink';
import { config } from '../../config/config';
import { CrossIcon, NotificationModalIcon } from '../../assets/icons';
import { useWeb3React } from '@web3-react/core';
import { SupportedChains } from '../../config/constants';

const WithdrawalPending: React.FC = () => {
    const { closeModal, modalData } = useContext(modalContext);
    const { chainId } = useWeb3React();
    const onClose = () => closeModal('withdrawalPending');

    return (
        <CustomModal modalName='withdrawalPending' className='withdrawal-pending'>
            <button type='button' onClick={onClose}>
                <CrossIcon />
            </button>
            <NotificationModalIcon />

            <div className='message'>
                Your <strong>Withdrawal</strong> will be marked as{' '}
                <strong>Pending</strong> until it is <strong>Ready to Withdraw</strong> on
                the next Do Hard Work, generally within{' '}
                {chainId === SupportedChains.ARBITRUM_ONE ? '24 hours' : '3 days'}. You
                can check its status within the Spool's details section. Final amounts may
                differ due to small variations in slippage.
            </div>
            <div className='link'>
                <ExternalLink
                    to={`${
                        chainId !== SupportedChains.ARBITRUM_ONE
                            ? config.urls.etherscan
                            : config.urls.arbiscan
                    }/tx/${modalData?.txHash}`}
                >
                    View on{' '}
                    {chainId !== SupportedChains.ARBITRUM_ONE ? 'Etherscan' : 'Arbiscan'}
                </ExternalLink>
            </div>
        </CustomModal>
    );
};

export default WithdrawalPending;
